// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"80d94331","703":"5cf60b74"}[chunkId] + ".chunk.js";
};